export default "__VITE_ASSET__005bef1c__"